<template>
  <div class="common-popover" v-show="isShow" :style="styleCss">
    <div class="title" v-if="title">
      <span>{{title}}</span>
    </div>
    <i class="el-icon-close" @click="closeTip"></i>
    <p class="body">
      {{msg}}
    </p>
    <div class="footer">
      <el-button size="mini" @click="okBtn">{{btnText}}</el-button>
    </div>
  </div>
</template>
<script>
  import Storage from 'common/storage';
  import {AccountInfo} from 'common/axios.js';
  export default {
    name: 'common-popover',
    props: {
      msg: String,
      title: String,
      btnText: String,
      popKey: String,
      styleCss: Object
    },
    data() {
      return {
        isShow: false
      }
    },
    computed: {
      storageKey() {
        const account = AccountInfo.getAccountFromSys();
        return `common-pop-${this.popKey}-${account.customerId}`;
      }
    },
    methods: {
      closeTip(e) {
        e && e.preventDefault();
        e && e.stopPropagation();
        Storage.set(this.storageKey, true);
        this.isShow = false;
      },
      okBtn(e) {
        this.closeTip(e);
        this.$emit('close');
      }
    },
    created() {
      this.isShow = !Storage.get(this.storageKey);
    }
  };
</script>
<style lang="scss">
  .common-popover {
    position: absolute;
    right: -300px;
    top: 0;
    width: 260px;
    padding: 12px 16px;
    border-radius: 12px;
    background-color: #0052D9;
    color: #fff;
    font-size: 12px;
    z-index: 1;
    &::before {
      display: block;
      content: " ";
      position: absolute;
      right: 12px;
      top: -6px;
      width: 0;
      height: 0;
      border-width: 6px;
      border-top-width: 0;
      border-color: transparent;
      border-bottom-color: #0052D9;
      border-style: solid;
    }
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }
    .body {
      padding: 10px 0;
      white-space: normal;
      line-height: 1.6;
    }
    .footer {
      text-align: right;
      .el-button {
        color: #0052D9;
        border-color: #0052D9;
        border-radius: 14px;
      }
    }
  }
</style>